import { render, staticRenderFns } from "./JudgeSearchModal.vue?vue&type=template&id=4fa0752c&scoped=true&"
import script from "./JudgeSearchModal.vue?vue&type=script&lang=js&"
export * from "./JudgeSearchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa0752c",
  null
  
)

export default component.exports